import { useEffect, useMemo } from 'react';

import {
  FEE_TYPE_FIXED,
  FEE_TYPE_PERCENTAGE
} from '../donations/donation-settings/TransactionFees';
import { calculatePercentageFee } from '../add-donation/DonationConfig';

import { useDonationContextProvider } from 'context/DonationContextProvider';

import { Form } from 'react-bootstrap';
import { formatMoney } from 'helpers/utils';

function CoverTransactionFee() {
  const {
    transactionFee: isCoverTransactionFeeChecked,
    setTransactionFee,
    basket,
    urgentAppeal,
    transactionFeeAmount,
    setTransactionFeeAmount
  } = useDonationContextProvider();

  const transactionFee = useMemo(() => {
    let totalFee = 0;

    // Calculate transaction fee for each item in basket based on its package's transaction_fee
    basket.forEach(item => {
      const itemTotal = item.count * item.donationAmount.value;
      const packageFee = item.transactionFee; // transaction_fee from the package

      if (packageFee) {
        // packageFee can be an object or array with fee_type and amount
        const fees = Array.isArray(packageFee) ? packageFee : [packageFee];

        fees.forEach(fee => {
          if (fee.fee_type === FEE_TYPE_PERCENTAGE) {
            totalFee += calculatePercentageFee(itemTotal, fee.amount);
          } else if (fee.fee_type === FEE_TYPE_FIXED) {
            totalFee += fee.amount * item.count;
          }
        });
      }
    });

    // Add fees for urgent appeals if they have transaction fees
    urgentAppeal.forEach(appeal => {
      const appealAmount = appeal.amount || 10;
      const appealFee = appeal.transactionFee;

      if (appealFee) {
        const fees = Array.isArray(appealFee) ? appealFee : [appealFee];

        fees.forEach(fee => {
          if (fee.fee_type === FEE_TYPE_PERCENTAGE) {
            totalFee += calculatePercentageFee(appealAmount, fee.amount);
          } else if (fee.fee_type === FEE_TYPE_FIXED) {
            totalFee += fee.amount;
          }
        });
      }
    });

    // Round to 2 decimal places to avoid floating point issues
    return Math.round(totalFee * 100) / 100;
  }, [basket, urgentAppeal]);

  useEffect(() => {
    setTransactionFeeAmount(transactionFee);
  }, [transactionFee, setTransactionFeeAmount]);

  return (
    <div className="wr-donation-summary-card wr-donation-text-brand-secondary mb-3 border border-primary border-2 rounded">
      <div className="text-uppercase wr-donation-header3 mb-3">
        Cover Transaction Fee
      </div>
      <div className="d-flex justify-content-between align-items-center">
        <Form.Check
          type="checkbox"
          className="m-0 d-flex align-items-center gap-2 custom-checkbox-lg"
        >
          <Form.Check.Input
            id="wr-donation-transction-fee-checkbox"
            isValid
            className="mt-0"
            checked={isCoverTransactionFeeChecked}
            onChange={e => setTransactionFee(e.target.checked)}
          />
          <label htmlFor="wr-donation-transction-fee-checkbox" className="mb-0 wr-donation-body1">
            I would like to cover the transaction fee
          </label>
        </Form.Check>
        <span className="fw-bold">{formatMoney(transactionFeeAmount, '£')}</span>
      </div>
    </div>
  );
}

export { CoverTransactionFee };
